import { action } from '@ember/object';
import { service } from '@ember/service';

import type { DSSetup, PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import BlockFiltersComponent from 'webapp/components/block/filters/index';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BlockFiltersPopupModalComponent extends PopupInnerModalComponent<PopupData.Block.Filters> {
	@service('analytics') declare analyticsService: Service.Analytics;

	get clearAndCloseFn() {
		// only if we have clear fn passed (for master filter)
		const clearFn = this.popupData.clear;
		if (clearFn) {
			return () => {
				clearFn();
				this.close();
			};
		}
		return undefined;
	}

	@action
	apply(dimensions: string[] | undefined, filters: DSSetup.MetricSetupFiltersData | null) {
		this.analyticsService.event(TrackingEvent.FILTER_DATA_SET, {
			origin: this.popupData.origin ?? 'designer',
			filters: filters?.groupItems[0]?.filterItems?.length || 0,
		});
		this.popupData.apply(dimensions, filters);
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Filter" @size="lg" />
			Filter data
		</div>

		<div class="content">
			<BlockFiltersComponent
				@popup={{@model}}
				@metricSetup={{this.popupData.metricSetup}}
				@close={{this.close}}
				@apply={{this.apply}}
				@clearAndClose={{this.clearAndCloseFn}}
				@editItem={{this.popupData.editItem}}
				@allowMultipleDimensions={{this.popupData.allowMultipleDimensions}}
				@theme={{@model.theme}}
			/>
		</div>
	</template>
}
